import * as React from "react"
import {useEffect} from "react"
import {Grid} from "@mui/material";
import {DrawerSeeker} from "@ui-seeker/core";

import {useUnmatchedNewProductsMappingForm} from "./@hooks";
import {brandForm, newProductsMultipleRowsEdit, newProductsRowEditClicked, skuForm} from "./@signals";
import {UnmatchedNewProductsBrandAutocomplete, UnmatchedNewProductsSkuAutocomplete} from "./@components";


export default function UnmatchedNewProductsMappingDrawer() {
	const { formData, formTitle, showForm, isMultipleMapping, saveNewMapping, saveMultipleNewMapping} = useUnmatchedNewProductsMappingForm()
	
	useEffect(() => {
		if (!isMultipleMapping)
			brandForm.value = formData?.brandID ? formData?.brandID : null
		skuForm.value = null
	}, [formData])

	if (!showForm) return <></>
	
	return <DrawerSeeker
		isOpen={showForm}
		controller={() => {
			newProductsRowEditClicked.value = null
			newProductsMultipleRowsEdit.value = []
		}}
		title={`EDIT ${formTitle}`}
		width="40%"
		successProps={{ onClick: !isMultipleMapping ? saveNewMapping : saveMultipleNewMapping }}
	>
		<Grid container spacing={4}>
			<Grid item xs={12}>
				<UnmatchedNewProductsBrandAutocomplete 
					value={brandForm.value} 
					multiple={false} 
					onChange={e => brandForm.value = e.target.value}
				/>
			</Grid>

			<Grid item xs={12}>
				<UnmatchedNewProductsSkuAutocomplete />
			</Grid>
		</Grid>
	</DrawerSeeker>
}